module.exports = __webpack_public_path__ + "img/naranja.7bd363e0.png";